export const hover = (parent: any, hoverObject: string) => {
  const shape = parent.findObject(hoverObject);
  if (shape.name === 'LINKSTROKE') {
    shape.strokeWidth = 8;
    shape.stroke = 'rgba(0,153,255,0.3)';
  }
};

export const unhover = (parent: any, hoverObject: string) => {
  const shape = parent.findObject(hoverObject);
  if (shape.name === 'LINKSTROKE') {
    shape.stroke = null;
  }
};
